import { connect } from 'react-redux';
import OrderUpdateFreight from '../components/Order/OrderUpdateFreight';
import { updateOrderFreight } from '../actions/orderActions';

const mapStateToProps = function (store) {
    return {
    };
};
const mapDispatchToProps = function (dispatch, ownProps) {
    return {
        onSubmit: (params, callback) =>
            dispatch(updateOrderFreight(params, callback)),
    };
};
const ConnectedOrderUpdateFreight = connect(
    mapStateToProps,
    mapDispatchToProps
)(OrderUpdateFreight);

export default ConnectedOrderUpdateFreight;
